export default function Announcer({ app: { router, store } }, inject) {
  function announce(message, live) {
    store.dispatch('ui/announce', { message, live: live || 'polite' })
  }

  inject('announce', announce)

  router.afterEach(() => {
    setTimeout(() => {
      const message = document.title.trim()
      const complementRoute = 'has loaded'

      announce(`${message} ${complementRoute}`)
    }, 500)
  })
}
